// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import common from './utils/common.js'
import iView from 'iview'
import 'iview/dist/styles/iview.css' 
import less from 'less'
import global_ from './components/global'
import {post,fetch} from './utils/http'
import Viewer from 'v-viewer'
import './assets/style.css'
import 'viewerjs/dist/viewer.css'
import Print from 'vue-print-nb'
import moment from "vue-moment"
import htmlToPdf from './utils/htmlToPdf'

Vue.prototype.$post=post;
Vue.prototype.$fetch=fetch;
Vue.prototype.common = common
Vue.prototype.GLOBAL = global_
Vue.config.productionTip = false
Vue.use(router)
Vue.use(iView)
Vue.use(less)
Vue.use(Viewer)
Vue.use(Print)
Vue.use(htmlToPdf)
Vue.use(moment);
Viewer.setDefaults({
  	Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,  //store:store 和router一样，将我们创建的Vuex实例挂载到这个vue实例中
	components: { App },
	template: '<App/>',
	data: {
		eventHub: new Vue()
	}
})



// WEBPACK FOOTER //
// ./src/main.js